import { IconName } from "@blueprintjs/core"
import LoginPage from "pages/login/LoginPage"
import React, { FunctionComponent, SVGProps } from "react"
import { RouteObject } from "react-router-dom"
import PageNotFound from "views/404.view"
import AboutPage from "pages/about"
import Main from "views/MainView/MainView"
import Privacy from "pages/privacy"
import TrackingPage from "pages/track/[id]"
import mainRoutes from "./main.routes"

export type VesaRouteType = RouteObject & {
  title?: string
  secondaryTitle?: string
  /**
   * @description If true then only render the route if process.env.REACT_APP_ENV === "production"
   */
  production?: boolean
  permission?: string[]
  icon?:
    | IconName
    | FunctionComponent<SVGProps<SVGSVGElement> & { title?: string }>
  hide?: boolean
  children?: VesaRouteType[]
  type?: string
  protected?: boolean
  parent?: string
}
const appRoutes: VesaRouteType[] = [
  {
    path: "*",
    title: "404",
    element: <PageNotFound />,
  },
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/d",
    protected: true,
    element: <Main />,
    children: mainRoutes,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/track/:id",
    element: <TrackingPage />,
  },
]

export default appRoutes
